import ForwardIcon from "@mui/icons-material/Forward";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IForwardToolButtonProps extends IconButtonProps {
}

export const ForwardToolButton = (props: IForwardToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={Translations.ForwardMessage}
        icon={<ForwardIcon />}
    />
);
